import EmbedCodeGenerator from '../../utils/embed';

export default class EmbedSingleEventController {
  constructor(ApiConfig, Account, $rootScope, $scope, $uibModalInstance, broadcast) {
    'ngInject';

    this.$scope = $scope;
    this.FeatureFlags = $rootScope.account.feature_flags;
    this.$uibModalInstance = $uibModalInstance;

    // This is passed via `resolve`
    this.broadcast = broadcast;

    // Output of embed directive
    this.output = {
      type: 'single',
      embedType: 'javascript',
      channelId: this.broadcast.channel_id,
      broadcast: this.broadcast,
      title: true,
      description: true,
      related: false,
      args: {
        applyBrandColor: true,
        showTitleAndDescription: true,
        showTitle: true,
        showDescription: true,
        showHighlights: false,
        showRelated: false,
        showCountdown: true,
      },
      embedCode: '',
      iframeCode: '',
      boxcastLink: '',
      boxcastTVLink: '',
      m3u8: this.broadcast.static_playlist_url,
      layout: 'player-and-title',
    };

    $scope.$watch(
      () => [
        this.output.type,
        this.output.channelId,
        this.output.title,
        this.output.description,
        this.output.related,
        this.output.args,
      ],
      (newVal, oldVal) => {
        var [type, channelId, title, description, related, args] = newVal;
        this.output.embedCode = EmbedCodeGenerator.v2WidgetEmbed(
          channelId,
          title,
          description,
          related
        );
        this.output.embedCode3 = EmbedCodeGenerator.v3WidgetEmbed(channelId, args);
        this.output.iframeCode = EmbedCodeGenerator.v2IframeEmbed(
          channelId,
          title,
          description,
          related
        );
        this.output.iframeCode3 = EmbedCodeGenerator.v3IframeEmbed(channelId, args);
        this.output.linkCode3 = EmbedCodeGenerator.v3Link(channelId, args);
        this.output.appCode3 = EmbedCodeGenerator.v3App(channelId, args);
        this.output.highlightsCode3 = EmbedCodeGenerator.v3Highlights(channelId, args);
        this.output.rss3 = EmbedCodeGenerator.v3Rss(channelId, args);
        this.output.audioMRSS3 = EmbedCodeGenerator.v3MRSS(channelId, 'audio', args);
        this.output.videoMRSS3 = EmbedCodeGenerator.v3MRSS(channelId, 'video', args);
        this.output.rokuDirectPublisher = EmbedCodeGenerator.rokuDirectPublisher(channelId, args);
        this.output.audioPodcast3 = EmbedCodeGenerator.v3Podcast(channelId, 'audio', args);
        this.output.videoPodcast3 = EmbedCodeGenerator.v3Podcast(channelId, 'video', args);
        this.output.boxcastLink = BOXCAST_SHOW_URL + channelId;
        this.output.boxcastTVLink = BOXCAST_TV_SHOW_URL + channelId;
      },
      true
    );

    this.output.args.market = $rootScope.account.market;
  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }
}



// WEBPACK FOOTER //
// ./app/pages/events/embed-single-event-controller.js